import { application } from '../axios.service'

export const ServiceDashboard = {
    getDashboard: (params) => application.get('/dashboard', { params }),
    getLastPosts: () => application.get('/dashboard/last-posts'),
    getLastActivities: () => application.get('/dashboard/last-activities'),
}
